import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Link, Routes, Navigate } from 'react-router-dom';
import GoalManager from './components/GoalManager';
import DidaProjects from './components/DidaProjects';
import RewardManager from './components/RewardManager';
import TaskTracker from './components/TaskTracker';
import Plans from './components/Plans/Plans';
import Login from './components/Login';
import CheckInManager from './components/CheckInManager';
import './App.css';

const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    return (
        <Router>
            <div>
                <nav className="navbar navbar-expand-lg navbar-light bg-light">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="/">Task Tracker</Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/">日程</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/goals">目标</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/plans">计划</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/rewards">奖励</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/checkIns">打卡</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/didaProjects">待办</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>

                <Routes>
                    <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
                    {isLoggedIn ? (
                        <>
                            <Route path="/" element={<TaskTracker />} />
                            <Route path="/goals" element={<GoalManager />} />
                            <Route path="/plans/*" element={<Plans />} />
                            <Route path="/rewards" element={<RewardManager />} />
                            <Route path="/didaProjects" element={<DidaProjects />} />
                            <Route path="/checkIns" element={<CheckInManager  />} />
                        </>
                    ) : (
                        <Route path="*" element={<Navigate to="/login" />} />
                    )}
                </Routes>
            </div>
        </Router>
    );
};

export default App;
